var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.603 48.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.972,28.723a2.95742,2.95742,0,0,1-2.288-.924,3.80459,3.80459,0,0,1-.916-2.996l.48-2.586a1.66679,1.66679,0,0,0-.325-1.295.806.806,0,0,0-.626-.27c-.043,0-4.227.27-4.227.27a3.32933,3.32933,0,0,1-.439.026C1.957,20.948,0,19.775,0,16.469,0,12.897,10.471,3.877,13.774,1.121a3.41036,3.41036,0,0,1,5.05-.006c2.44,1.97,13.779,11.337,13.779,15.354a5.0979,5.0979,0,0,1-.971,3.33,3.2476,3.2476,0,0,1-2.596,1.155,4.691,4.691,0,0,1-.563-.036l-3.979-.246a1.73116,1.73116,0,0,0-.188-.014.816.816,0,0,0-.626.276,1.6928,1.6928,0,0,0-.323,1.308l.479,2.613a3.702,3.702,0,0,1-.917,2.942,2.93538,2.93538,0,0,1-2.284.926Z",
    fill: "#1a8bc3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.141,1.847a2.416,2.416,0,0,0-3.674,0S1,13.068,1,16.47c0,2.549,1.354,3.66,3.008,3.457l4.037-.252c1.379-.166,2.367,1.035,2.197,2.672l-.48,2.613c-.17,1.637.655,2.763,2.041,2.763h9c1.387,0,2.212-1.126,2.042-2.763l-.479-2.613c-.17-1.637.817-2.838,2.196-2.672l4.037.252c1.654.203,3.009-.674,3.009-3.457C31.608,12.693,18.141,1.847,18.141,1.847Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.803,44.723a4,4,0,0,1-4,4h-8a4,4,0,0,1-4-4v-1a4,4,0,0,1,4-4h8a4,4,0,0,1,4,4Z",
    fill: "#1a8bc3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.803,44.723a3,3,0,0,1-3,3h-8a3,3,0,0,1-3-3v-1a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.803,34.723a4,4,0,0,1-4,4h-8a4,4,0,0,1-4-4v-1a4,4,0,0,1,4-4h8a4,4,0,0,1,4,4Z",
    fill: "#1a8bc3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.803,34.723a3,3,0,0,1-3,3h-8a3,3,0,0,1-3-3v-1a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.46e9e1a547a7bea7311a34a31a0b9e03.svg";
export { ForwardRef as ReactComponent };